import React, { Component } from "react"

class ErrorBoundary extends Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, info) {
		console.error("ErrorBoundary caught:", error, info)

		if (this.props.onError) {
			this.props.onError(error, info)
		}
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback
			return <div>Something went wrong.</div>
		}

		return this.props.children
	}
}

export default ErrorBoundary
